/**
 * Card slideshow: arrow controls for the scroll-snap track.
 *
 * Arrows only appear when the cards overflow the row (more than three from
 * tablet up). Each click moves one card. Without JS the track still scrolls
 * sideways with its scrollbar.
 */
( function () {
	'use strict';

	window.Blockline = window.Blockline || {};

	var reduceMotion = window.matchMedia( '(prefers-reduced-motion: reduce)' );

	function setup( root ) {
		var track = root.querySelector( '[data-card-slideshow-track]' );
		var controls = root.querySelector( '[data-card-slideshow-controls]' );

		if ( ! track || ! controls ) {
			return;
		}

		var prev = controls.querySelector( '[data-card-slideshow-prev]' );
		var next = controls.querySelector( '[data-card-slideshow-next]' );

		// One card width plus the gap.
		function step() {
			var card = track.firstElementChild;
			var gap = parseFloat( window.getComputedStyle( track ).columnGap ) || 0;

			return card ? card.getBoundingClientRect().width + gap : track.clientWidth;
		}

		function update() {
			var max = track.scrollWidth - track.clientWidth;

			controls.hidden = max <= 1;
			prev.disabled = track.scrollLeft <= 1;
			next.disabled = track.scrollLeft >= max - 1;
		}

		function go( direction ) {
			track.scrollBy( {
				left: direction * step(),
				behavior: reduceMotion.matches ? 'auto' : 'smooth',
			} );
		}

		prev.addEventListener( 'click', function () {
			go( -1 );
		} );

		next.addEventListener( 'click', function () {
			go( 1 );
		} );

		track.addEventListener( 'scroll', update, { passive: true } );

		if ( 'ResizeObserver' in window ) {
			new window.ResizeObserver( update ).observe( track );
		} else {
			window.addEventListener( 'resize', update );
		}

		root.classList.add( 'is-enhanced' );
		update();
	}

	window.Blockline.cardSlideshow = {
		init: function () {
			Array.prototype.forEach.call( document.querySelectorAll( '[data-card-slideshow]' ), setup );
		},
	};
} )();